import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { GoHome } from "react-icons/go";
import { IoCreateOutline } from "react-icons/io5";
import { HiOutlineNewspaper } from "react-icons/hi2";
import { TbReportAnalytics } from "react-icons/tb";
import {
  AiOutlineSetting,
  AiOutlineUsergroupAdd,
  // AiOutlineUser,
} from "react-icons/ai";
import { GrWorkshop } from "react-icons/gr";
import { SlPeople } from "react-icons/sl";
import { MdOutlineNoteAdd, MdOutlineAddCircleOutline } from "react-icons/md";
import { Layers, Users } from "lucide-react";
import img from "../../constant";
import { useAuth } from "../../screens/auth/hooks/useAuth";

const AdminLayout = ({ children }: any) => {
  const { isSuperAdmin } = useAuth();
  // const { organizationData } = useOrganizationData();
  // const { organizations } = getOrgAdmins();
  const customItems = [
    {
      icon: <GoHome size={22} className="text-lg" />,
      label: "Dashboard",
      path: "/dashboard",
    },
    {
      icon: <AiOutlineUsergroupAdd size={22} className="text-lg" />,
      label: "Create Interview",
      path: "/create-interview",
    },
    {
      icon: <HiOutlineNewspaper size={22} className="text-lg" />,
      label: "View Interviews",
      path: "/interviews",
    },
    {
      icon: <IoCreateOutline size={22} className="text-lg" />,
      label: "Add Job",
      path: "/create-job",
    },
    {
      icon: <MdOutlineNoteAdd size={22} className="text-lg" />,
      label: "Pretest/Assesment",
      path: "/pretests",
    },

    {
      icon: <GrWorkshop size={20} className="text-lg" />,
      label: "View Jobs",
      path: "/jobs",
    },

    {
      icon: <SlPeople size={20} className="text-lg" />,
      label: "View Candidates",
      path: "/candidates",
    },
    // {
    //   icon: <TbReportAnalytics size={22} className="text-lg" />,
    //   label: "Interview Reports",
    //   path: "/candidates",
    // },
    {
      icon: <TbReportAnalytics size={22} className="text-lg" />,
      label: "Subscriptions",
      path: "/subscriptions/renew",
    },
    {
      icon: <AiOutlineSetting size={22} className="text-lg" />,
      label: "Documents",
      path: "/documents",
    },
    {
      icon: <AiOutlineSetting size={22} className="text-lg" />,
      label: "Settings",
      path: "/settings/profile",
    },
    ...(isSuperAdmin
      ? [
          {
            icon: <AiOutlineSetting size={22} className="text-lg" />,
            label: "Demo Requests",
            path: "/admins",
          },
          {
            icon: <AiOutlineSetting size={22} className="text-lg" />,
            label: "Agreements",
            path: "/agreements",
          },
          {
            icon: <HiOutlineNewspaper size={22} className="text-lg" />,
            label: "Bulk Send Post-Onboard",
            path: "/admin/bulk-post-onboard",
          },
          {
            icon: <MdOutlineAddCircleOutline size={22} className="text-lg" />,
            label: "Create Plan",
            path: "/admin/plans/create",
          },
          {
            icon: <MdOutlineAddCircleOutline size={22} className="text-lg" />,
            label: "Create Add-on",
            path: "/admin/addons/create",
          },
          {
            icon: <Layers size={22} className="text-lg" />,
            label: "Services/Features",
            path: "/admin/offerings",
          },
          {
            icon: <Users size={22} className="text-lg" />,
            label: "Onboarding Clients",
            path: "/onboarding-clients",
          },
        ]
      : []),
  ];

  return (
    <div className="flex w-full bg-[#F7F7F7] font-abel">
      <Sidebar
        items={customItems as any[]}
        logo={<img src={img.logo2} alt="25th" />}
        defaultCollapsed={false}
        onToggleCollapse={(collapsed) =>
          console.log("Sidebar collapsed:", collapsed)
        }
      />

      <main className="w-full h-screen overflow-scroll">
        {/* <UpgradeNow
          className={
            organizationData?.subscriptionTier === "FREE" ? "flex" : "hidden"
          }
        /> */}
        <Navbar />
        <div className="bg-[#F2F5FF] py-3">
          <div className="max-w-[1096px] mx-auto px-3">
            <p className="text-secondary text-20">AI Recruiter</p>
          </div>
        </div>
        <div>{children}</div>
      </main>
    </div>
  );
};

export default AdminLayout;
